import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';

@Injectable()
export class PushNotificationValidator {
  constructor() {}

  static ValidateDates = (control: AbstractControl) => {
    const group = control as FormGroup;
    if (group.controls.ActiveFrom.dirty === true || group.controls.ActiveTill.dirty === true) {

      const startDate = group.controls.ActiveFrom.value;
      const endDate = group.controls.ActiveTill.value;

      // Incomplete datetime: control is dirty but value is null (date filled without time)
      const startIncomplete = group.controls.ActiveFrom.dirty && startDate === null;
      const endIncomplete = group.controls.ActiveTill.dirty && endDate === null;

      // Paired requirement: one date filled, other empty
      const startMissing = !startIncomplete && startDate === null && endDate !== null;
      const endMissing = !endIncomplete && endDate === null && startDate !== null;

      if (startIncomplete || startMissing) {
        group.controls.ActiveFrom.setErrors({required: true}, {emitEvent: true});
      }
      if (endIncomplete || endMissing) {
        group.controls.ActiveTill.setErrors({required: true}, {emitEvent: true});
      }

      if (startIncomplete || endIncomplete || startMissing || endMissing) {
        return {required: true};
      }

      // Both filled: check date order
      if (startDate > endDate) {
        group.controls.ActiveFrom.setErrors({startDateAfterEndDate: true}, {emitEvent: true});
        group.controls.ActiveTill.setErrors({endDateBeforeStartDate: true}, {emitEvent: true});

        return ({startDateAfterEndDate: true, endDateBeforeStartDate: true});
      } else {
        if (group.controls.ActiveFrom.hasError('startDateAfterEndDate')) {
          group.controls.ActiveFrom.setErrors(null, {emitEvent: true});
        }
        if (group.controls.ActiveTill.hasError('endDateBeforeStartDate')) {
          group.controls.ActiveTill.setErrors(null, {emitEvent: true});
        }
        if (group.controls.ActiveFrom.hasError('required')) {
          group.controls.ActiveFrom.setErrors(null, {emitEvent: true});
        }
        if (group.controls.ActiveTill.hasError('required')) {
          group.controls.ActiveTill.setErrors(null, {emitEvent: true});
        }
        return null;
      }
    }
    return null;
  }
}
